// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"610":"012b9afb","615":"4cdf550e","900":"66a65d1d"}[chunkId] + ".chunk.js";
};